<template>
    <div class="check-box-input">
        <v-switch
                v-model="switcher"
                @change="swithHandler($event)"
                inset
                :label="$t(item.t)"
                color="#5b8ff5"
                :disabled="isReadOnly ? isReadOnly : item.disabled"
        ></v-switch>
        <v-text-field
                v-if="showInput"
                v-model="input"
                outlined
                type="number"
                @input="inputHandler()"
                :disabled="isReadOnly ? isReadOnly : item.disabled"
        ></v-text-field>
    </div>
</template>

<script>

    export default {
        name: "CheckBoxInput",
        model: {
            prop: 'checked',
            event: 'change'
        },
        props: ['checked', 'item', 'isReadOnly'],

        data() {
            return {
                switcher: false,
                input: '',
                showInput: false
            }
        },
        watch: {
            checked(v) {
                if (v === -1 || v === '-1') {
                    this.switcher = false;
                    this.showInput = false;
                    this.input = '';
                } else {
                    this.switcher = true;
                    this.showInput = true;
                    this.input = v;
                }
            }

        },
        methods: {
            swithHandler(e) {
                this.showInput = e;
                if(!e) {
                    this.$emit('change', '-1');
                } else {
                    this.$emit('change', this.input);
                }
            },
            inputHandler() {
                this.$emit('change', this.input);
            },
        },
        updated() {

        },
    }
</script>